import { useRequest } from "./useRequest"
import { useSelector, useDispatch } from "react-redux"
import { categories as actions } from "../actions"
import { categorySelector } from "../selectors"

export const useCategories = (subdomain: string, calendarId: string) => {
  const dispatch = useDispatch()
  const request = async () =>
    await dispatch(actions.requestCategory(subdomain, calendarId, null))
  const categories = useSelector(categorySelector.forCalendar)(
    calendarId
  ).filter((c: any) => c.name !== "Notes")
  const { loading, refetch } = useRequest(request)
  return { loading, categories, refetch }
}
